import styled from "styled-components";

const SecondaryTitle = styled.h2`
  color: #fbb700;
  font-weight: bold;
  text-align: center;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export default SecondaryTitle;
